import { Link } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { Link as RouterLink, useNavigate } from "react-router";

import type { AdminAccountLimit } from "../../generic/server/supabase-account-service";
import type { GridColDef, GridEventListener } from "@mui/x-data-grid-pro";
import type { FC } from "react";

const COLUMNS: GridColDef<AdminAccountLimit>[] = [
  {
    field: "name",
    headerName: "Account Name",
    flex: 1,
    renderCell: ({ row, value }) => (
      <Link
        component={RouterLink}
        to={`/ce_admin/accounts/${row.id}`}
        color="inherit"
        underline="hover"
      >
        {value}
      </Link>
    ),
  },
  { field: "business_name", headerName: "Business Name", flex: 1 },
  { field: "usage", headerName: "Usage", width: 120 },
  { field: "churned", headerName: "Churned", width: 110, type: "boolean" },
  {
    field: "domain",
    headerName: "Domain",
    flex: 1,
    valueGetter: (_value, row) => row.domain ?? "",
  },
];

export const AccountListGrid: FC<{ accounts: AdminAccountLimit[] }> = ({ accounts }) => {
  const navigate = useNavigate();

  const handleRowClick: GridEventListener<"rowClick"> = (params, event) => {
    // Links handle their own clicks, so ctrl/cmd-click can open them in a new tab
    if (event.target instanceof Element && event.target.closest("a")) return;
    void navigate(`/ce_admin/accounts/${params.row.id}`);
  };

  return (
    <DataGridPro<AdminAccountLimit>
      rows={accounts}
      columns={COLUMNS}
      onRowClick={handleRowClick}
      disableRowSelectionOnClick
      pagination
      showToolbar
      pageSizeOptions={[10, 25, 50]}
      initialState={{
        pagination: { paginationModel: { pageSize: 25 } },
        filter: {
          filterModel: {
            items: [{ id: "churned", field: "churned", operator: "is", value: false }],
          },
        },
        sorting: { sortModel: [{ field: "name", sort: "asc" }] },
      }}
      sx={{ "& .MuiDataGrid-row": { cursor: "pointer" } }}
    />
  );
};
